/*
 * Motion carousel - behaviour only.
 *
 * The marquee, its cards and the quick-buy modals are rendered by
 * sections/motion-carousel.liquid, and the scrolling itself is a CSS
 * animation. Products with options open the theme's own quick-buy modal
 * through its aria-controls binding, so nothing here handles that either.
 *
 * What is left: pausing on touch, adding a single-variant product to the
 * cart, and reporting clicks.
 *
 * Ported from the Variant experience exp-EXP57053BF3.
 */
(function () {
  'use strict';

  var HOLD_BEFORE_PAUSE_MS = 200;
  var RESET_LABEL_MS = 2000;

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function init(root) {
    if (root.dataset.motionCarouselReady) return;
    root.dataset.motionCarouselReady = '1';

    var track = root.querySelector('[data-motion-carousel-track]');
    if (!track) return;

    var analyticsOn = !root.hasAttribute('data-analytics-off');
    var experimentId = root.getAttribute('data-experiment-id') || '';
    var variationId = root.getAttribute('data-variation-id') || '';

    function report(eventName, extra) {
      if (!analyticsOn) return;
      try {
        if (typeof Variant === 'undefined' || !Variant.publishCustomEvent) return;
        var payload = { experiment_id: experimentId, variation_id: variationId };
        for (var key in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, key)) payload[key] = extra[key];
        }
        Variant.publishCustomEvent(eventName, payload);
      } catch (e) {
        /* never break the page for analytics */
      }
    }

    // -----------------------------------------------------------------------
    // Pause on touch. Hover is handled in CSS.
    //
    // The delay is what tells a tap-to-open apart from a press-to-read: a
    // finger that starts moving is scrolling the page, not holding the strip.
    // -----------------------------------------------------------------------
    var holdTimer = null;

    function pause() {
      track.classList.add('is-paused');
    }

    function resume() {
      clearTimeout(holdTimer);
      track.classList.remove('is-paused');
    }

    track.addEventListener(
      'touchstart',
      function () {
        clearTimeout(holdTimer);
        holdTimer = setTimeout(pause, HOLD_BEFORE_PAUSE_MS);
      },
      { passive: true }
    );

    track.addEventListener('touchmove', function () { clearTimeout(holdTimer); }, { passive: true });
    track.addEventListener('touchend', resume, { passive: true });
    track.addEventListener('touchcancel', resume, { passive: true });

    // -----------------------------------------------------------------------
    // Clicks
    // -----------------------------------------------------------------------
    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-motion-carousel-link]');
      if (link) {
        // The link navigates on its own; the event goes out alongside it.
        report('product-clicked-attribution', { product_id: link.getAttribute('data-product-id') });
        return;
      }

      var button = event.target.closest('[data-motion-carousel-add]');
      if (button) {
        event.preventDefault();
        addToCart(button);
      }
    });

    function addToCart(button) {
      var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
      if (!variantId || button.disabled) return;

      report('influenced-revenue', { product_id: button.getAttribute('data-product-id') });

      var restingLabel = button.textContent;
      button.disabled = true;

      var sections = ['cart-drawer', 'header']
        .map(function (name) {
          var element = document.querySelector('.shopify-section[id*="' + name + '"]');
          return element ? element.id.replace('shopify-section-', '') : null;
        })
        .filter(Boolean);

      var body = { items: [{ id: variantId, quantity: 1 }] };
      if (sections.length) {
        body.sections = sections.join(',');
        body.sections_url = window.location.pathname;
      }

      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          if (!json || json.status) throw new Error('add failed');

          if (json.sections) {
            Object.keys(json.sections).forEach(function (id) {
              var html = json.sections[id];
              if (html == null) return;
              var element = document.getElementById('shopify-section-' + id);
              if (!element) return;
              element.outerHTML = html;
              document.dispatchEvent(
                new CustomEvent('shopify:section:load', { detail: { sectionId: id } })
              );
            });
          }

          button.textContent = '✓ נוסף לסל';
          button.classList.add('is-added');

          requestAnimationFrame(function () {
            var drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.setAttribute('open', '');
          });

          settle(button, restingLabel, 'is-added');
        })
        .catch(function () {
          button.textContent = 'שגיאה';
          button.classList.add('is-failed');
          settle(button, restingLabel, 'is-failed');
        });
    }

    function settle(button, restingLabel, stateClass) {
      setTimeout(function () {
        button.textContent = restingLabel;
        button.classList.remove(stateClass);
        button.disabled = false;
      }, RESET_LABEL_MS);
    }
  }

  function boot() {
    document.querySelectorAll('[data-motion-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
